<template>
  <div
    :class="[
      baseClass,
      { 'flex-col-reverse' : flip }
    ]"
  >
    <div
      v-if="!noHeader"
      :class="[
        headerClass,
        { 'cursor-pointer' : clickable && !disabled }
      ]"
      @click="handleHeaderClick()"
    >
      <slot name="header" :visible="show" :toggle="toggle" />
      <slot name="toggle" :visible="show" :toggle="toggle">
        <!--<o-icon v-if="showToggle" icon="accordion" :size="12" class="pr-1" />-->
        <o-button
          v-if="showToggle && !disabled"
          size="sm"
          flat
          icon="accordion"
          class="-mr-1"
        />
      </slot>
    </div>
    <transition
      name="expand"
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave"
    >
      <div v-if="show" :class="bodyClass">
        <div>
          <slot :active="show" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
export default { name: 'OCollapse' }
</script>

<script setup lang="ts">
interface Props {
  visible?: boolean
  showToggle?: boolean
  clickable?: boolean
  baseClass?: string | string[]
  headerClass?: string | string[]
  bodyClass?: string | string[]
  icon?: string
  flip?: boolean
  noHeader?: boolean
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  visible: false,
  showToggle: true,
  clickable: true,
  baseClass: 'flex flex-col w-full',
  headerClass: '',
  bodyClass: '',
  icon: 'accordion',
  flip: false,
  noHeader: false,
  disabled: false,
})

const emit = defineEmits<{
  (e: 'update:active', value: boolean): void
  (e: 'toggle'): void
}>()

const show = ref(props.visible)

watch(show, (value) => {
  emit('update:active', value)
})

function toggle() {
  show.value = !show.value
}

function open() {
  show.value = true
}

function close() {
  show.value = false
}

function afterEnter(el: HTMLElement) {
  el.style.height = 'auto'
}

function enter(el: HTMLElement) {
  requestAnimationFrame(() => {
    el.style.height = el.scrollHeight + 'px'
  })
  emit('toggle')
}

function leave(el: HTMLElement) {
  el.style.height = el.scrollHeight + 'px'
  requestAnimationFrame(() => {
    el.style.height = '0'
  })
  emit('toggle')
}

function handleHeaderClick() {
  if (props.clickable && !props.disabled) {
    toggle()
  }
}

defineExpose({ open, close, toggle })
</script>

<style>
.expand-enter-active,
.expand-leave-active {
  transition: height 0.2s ease-in-out;
  overflow-y: hidden;
}
.expand-enter-from,
.expand-leave-to {
  height: 0;
}
</style>
